<template>
  <div class="shedListBar" ref="shedListBar">
    <div class="shedBar">
      <ul>
        <li v-bind:key="i" v-for="(item, i) in shedList">
          <a v-if="customerId == 42" @click="openShed(item)" class="shedOj__"><span>●&nbsp;&nbsp;</span><span
              :class="{ isVDM: item.isVDM ? true : false }">{{
                item.shedName + (item.isVDM ? "(VDM15000)" : "")
              }}</span></a>
          <a v-else @click="moveToShed(item, i)" @dblclick="openShed(item)"
            class="shedOj__"><span>●&nbsp;&nbsp;</span><span :class="{ isVDM: item.isVDM ? true : false }">{{
              item.shedName + (item.isVDM ? "(VDM15000)" : "")
            }}</span></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  inject: ["updateShedObj", "updateShedList"],
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'shed_list.vue',
      computedName: '重点监控点组件',
      shedList: [],
      timer: null,
      customerId: this.$store.state.customerId,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return "thClass_";
        } else {
          return "thClass";
        }
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return "tdClass_";
        } else {
          return "tdClass";
        }
      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },
  },
  //监控data中的数据变化
  watch: {
    "$store.state.materialShedObj": {
      handler(newVal) {
        if (newVal) {
          let item = this.shedList.find((ele) => ele.shedNo === newVal.shedNo);
          if (item) {
            this.moveToShed(item);
          }
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.shedListBar).outerWidth();
    let h = $(that.$refs.shedListBar).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getShedList();

    if (this.$store.state.customerId == 39) {
      this.shedList.push({
        area: "41400.00",
        areaId: null,
        areaName: "4#电子围栏料棚",
        id: 149,
        latitude: 31.85842845,
        leng: null,
        length: 460,
        longitude: 120.7352649,
        material: "铁矿粉、混匀矿、炼钢污泥、块矿",
        shedImg: null,
        shedName: "4#电子围栏料棚",
        shedNo: "39_004",
        type: 1,
        width: 120,
        isVDM: true,
      });
    }
  },
  //方法集合
  methods: {
    getShedList() {
      let that = this;
      let getShedListUrl = CONFIG.requestName + this.$apiOpt.findShedList;
      this.$apiUtils
        .get(getShedListUrl, {
          customerId: this.$store.state.customerId,
        })
        .then(function (data) {
          if (that.$store.state.currentWSCMD && that.customerId == 42) {
            let new_shed = [
              {
                id: 161,
                shedName: "焦炭大棚",
                shedNo: "38_001",
                material: "精矿粉，焦炭，白云石；",
                type: 0,
                shedImg: null,
                areaId: null,
                areaName: null,
                longitude: null,
                latitude: null,
                area: "5760.00",
                length: null,
                width: null,
                leng: null,
                isVDM: true,
              },
            ];
            that.shedList = new_shed.concat(data);
            that.updateShedList(data);
            that.getVDM1500LIstanbul();
            setTimeout(() => {
              let dom = document.getElementsByClassName("shedOj__")[0];
              dom.className = "actived";
            }, 1000);
            setTimeout(() => {
              that.openShed(new_shed[0]);
            }, 5000);
          } else {
            that.shedList = data;
            that.updateShedList(data);
            that.getVDM1500LIstanbul();
          }
        });
    },
    getVDM1500LIstanbul() {
      let that = this;
      // let getVdmListUrl = "https://screen.bmetech.com/screen/vdm15000/list";
      let getVdmListUrl = "https://vis.bmetech.com/vis/vdm15000/list";
      this.$apiUtils
        .get(getVdmListUrl, {
          customerId: this.$store.state.customerId,
        })
        .then(function (data) {
          //that.shedList = data;
          data.forEach((element) => {
            element.isVDM = true;
            that.shedList.push(element);
          });
          that.updateShedList(that.shedList);
        });
    },
    moveToShed(obj, index) {
      this.updateShedObj(obj, index);
    },
    openShed(obj) {
      let that = this;
      if (
        this.$store.state.customerId == 39 &&
        obj.shedName == "四车间电子料场"
      ) {
        console.log("打开四料棚");
        this.$store.commit("updateShowShed", true);
      } else {
        this.$store.commit("updateDbMaterialObj", "");

        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          that.$store.commit("updateDbMaterialObj", obj);
        }, 500)
      }
    },
  },
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.shedListBar {
  position: absolute;
  width: 300px;
  height: 790px;

  .shedBar {
    width: 250px;
    height: 720px;
    position: absolute;
    top: 55px;
    bottom: 20px;
    overflow: scroll;
  }

  ul {
    position: relative;
  }

  li {
    a {
      //width: 230px;
      padding: 0 10px 0 10px;
      height: 60px;
      font-size: 18px;
      font-family: "normalFont";
      font-weight: 400;
      color: #909090;
      line-height: 60px;
      background: rgba(1, 18, 43, 0.3);
      box-shadow: 0px 0px 6px 0px rgb(164 255 186 / 0%);
      margin-bottom: 2px;
      display: block;
      overflow: hidden;

      span {
        color: #909090;
        font-size: 22px;
        white-space: nowrap;
      }

      .isVDM {
        color: red;
      }
    }

    a:hover {
      background: rgba(1, 18, 43, 0.81);
      color: #a4ffba;

      span {
        color: #a4ffba;
        font-size: 22px;
      }
    }
  }
}

.actived {
  background: rgba(1, 18, 43, 0.81) !important;
  color: #a4ffba !important;

  span {
    color: #a4ffba !important;
    font-size: 22px !important;
  }
}
</style>
